export interface TronMulticallResponse {
    returnData: string[];
    results: boolean[];
}
